import * as React from "react";
const SvgButtonCopy = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	id: "Copy-Paste--Streamline-Streamline-3.0",
	height: 24,
	width: 24,
	...props
}, /* @__PURE__ */ React.createElement("desc", null, "\n		Copy Paste Streamline Icon: https://streamlinehq.com\n	"), /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("title", null, "copy-paste"), /* @__PURE__ */ React.createElement("path", {
	d: "M20.25 8.249v-3a1.5 1.5 0 0 0 -1.5 -1.5h-4",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "M6.25 3.749h-4a1.5 1.5 0 0 0 -1.5 1.5v16.5a1.5 1.5 0 0 0 1.5 1.5h6",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "M14.421 4.736a0.751 0.751 0 0 1 -0.712 0.513H7.291a0.751 0.751 0 0 1 -0.712 -0.513l-1 -3a0.749 0.749 0 0 1 0.712 -0.987h8.418a0.749 0.749 0 0 1 0.712 0.987Z",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "M12.75 11.249h9s1.5 0 1.5 1.5v9s0 1.5 -1.5 1.5h-9s-1.5 0 -1.5 -1.5v-9s0 -1.5 1.5 -1.5",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "m14.25 14.249 6 0",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "m14.25 17.249 6 0",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "m14.25 20.249 2.25 0",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}));
export { SvgButtonCopy as ReactComponent };
